import React from 'react';

const BottomButtonGroup = ({ buttons, step }) => {
  const containerClass = step === 1 ? 'bottom_btn' : 'bottom_btn flex jc_between';

  return (
    <div className={containerClass}>
      {buttons.map((button, index) => (
        <React.Fragment key={index}>
          {button.description}
          <button key={index} className={button.className} onClick={button.onClick} disabled={button.disabled}>
            {button.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default BottomButtonGroup;
